<template>
    <div>
        <InfoScreen></InfoScreen>
    </div>
</template>

<script>
export default {
    name: 'Play',
    props: {
        balance: Number,
        timeout: Number,
        gameId: Number,
    },
    data() {
        return {
            polling: null
        }
    },
    created() {
        window.addEventListener('keydown', this.listenOnKey);

        if (this.balance === 0) {
            this.leaveAfterTimeout();
        }

        Echo
            .private(`player-${this.$page.props.user.id}`)
            .listen('BalanceChanged', (e) => {
                if (e.balance <= 0) {
                    this.leaveAfterTimeout();
                } else {
                    clearTimeout(this.polling);
                }
            })

    },
    methods: {
        leaveAfterTimeout() {
            clearTimeout(this.polling);

            this.polling = setTimeout(async () => {
                const balance = await axios.get(this.route('terminal.balance'));
                if (balance.data.balance <= 0) {
                    this.goToLobby();
                }
            }, this.timeout)
        },
        goToLobby() {
            window.location.replace(this.route('terminal.lobby').url());
        },
        async listenOnKey(e) {
            if (e.key === 'h') {
                const response = await axios.get(this.route('terminal.open-round', this.gameId).url());
                if (!response.data['open-rounds'].length) {
                    this.goToLobby();
                }
            }
            if (e.key === 'c') {
                const response = await axios.get(this.route('terminal.open-round', this.gameId).url());
                if (!response.data['open-rounds'].length) {
                    window.location.replace(this.route('terminal.lobby', { withdrawal: true }).url())
                }
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.listenOnKey);
    }
}
</script>
